// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"137ab126","258":"7e484637","370":"205ab9e2","619":"0979ebb6","625":"d2303537","706":"205ab9e2","949":"70786f35"}[chunkId] + ".chunk.css";
};